// src/config.js
const config = {
  apiUrl: 'https://api.getwatted.nz',
  // apiUrl: 'http://localhost:8000',
  environment: process.env.NODE_ENV || 'development',
};

export default config;